import { render, staticRenderFns } from "./popover-item.vue?vue&type=template&id=5cb74712&scoped=true&lang=pug&"
import script from "./popover-item.vue?vue&type=script&lang=js&"
export * from "./popover-item.vue?vue&type=script&lang=js&"
import style0 from "./popover.styl?vue&type=style&index=0&id=5cb74712&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cb74712",
  null
  
)

export default component.exports